<template>
<div>
  <div>
    <label>题干: </label>
    <pinyin :text="entity.subject.text" :pinyin="entity.subject.pinyin"></pinyin>
  </div>

  <div class="mt8" v-if="entity.tips && entity.tips.length > 0">
    <label>提示: </label>
    <div>
      <div v-for="(item, key) in entity.tips" :key="key">
        <pinyin :text="item.text" :pinyin="item.pinyin"></pinyin>
      </div>
    </div>
  </div>

  <div class="mt8" v-if="entity.questions && entity.questions.length > 0">
    <label>提问: </label>
    <div>
      <div v-for="(item, key) in entity.questions" :key="key">
        <pinyin :text="item.text" :pinyin="item.pinyin"></pinyin>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import pinyin from "@/components/PinyinPreview.vue";
  // import ImageView from "@/components/ImageView.vue";
  // import AudioView from "@/components/AudioView.vue";

  export default {
    name: 'HdwtView',
    components: { pinyin },
    props: {
      type: {
        type: Object,
        default: () => {
          return {}
        }
      },
      entity: {
        type: Object,
        default: () => {
          return {}
        }
      },
      theme: {
        type: String,
        default: 'card'
      }
    },
    data () {
      return {}
    }
  }
</script>